import { Skeleton } from '@/components/ui/skeleton';

const ROW_COUNT = 6;

type UserMappingListSkeletonProps = {
  /** Visible status line. Omit for silent skeleton-only loading. */
  label?: string;
  /** Secondary line under `label`. */
  hint?: string;
};

/**
 * Placeholder rows matching the AI connector user-mapping list
 * (name/email + combobox column). Reserves height to limit CLS.
 */
export function UserMappingListSkeleton({
  label,
  hint,
}: UserMappingListSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className="flex flex-col"
    >
      {label ? (
        <div className="flex flex-col gap-1 px-6 py-3 border-b border-ds-border-subtlest">
          <p className="text-sm text-ds-text-subtle">{label}</p>
          {hint ? (
            <p className="text-xs text-ds-text-subtler">{hint}</p>
          ) : null}
        </div>
      ) : null}
      {Array.from({ length: ROW_COUNT }, (_, index) => (
        <div
          key={`mapping-skel-${index}`}
          className={`px-6 py-4 grid grid-cols-2 gap-6 items-center ${
            index > 0 ? 'border-t border-ds-border-subtlest' : ''
          }`}
        >
          <div className="flex flex-col gap-2 min-w-0">
            <Skeleton
              className="h-4 w-36 max-w-full bg-ds-gray-subtler"
              aria-hidden
            />
            <Skeleton
              className="h-3 w-48 max-w-full bg-ds-gray-subtler"
              aria-hidden
            />
          </div>
          <Skeleton className="h-10 w-full bg-ds-gray-subtler" aria-hidden />
        </div>
      ))}
    </div>
  );
}
